import { MenuItem } from "@mui/material";
import { Tag } from "lucide-react";
import { useState } from "react";
import MarkAsAvailableModal from "../mark-as-available";
import { useReadonlyContext } from "@/modules/common/context/read-only.context";

export default function MarkAsAvailableMenuItem({
  listingUid,
}: {
  listingUid: string;
}) {
  const [open, setOpen] = useState(false);

  const { readonly } = useReadonlyContext();

  return (
    <>
      <MenuItem
      disabled={readonly}
        sx={(theme) => ({
          display: "flex",
          gap: theme.nawy.spacing.xs,
        })}
        onClick={() => setOpen(true)}
      >
        <Tag />
        Mark as available
      </MenuItem>
      <MarkAsAvailableModal
        open={open}
        setOpen={setOpen}
        listingUid={listingUid}
      />
    </>
  );
}
